<template>
    <div class="h5 font-weight-bold">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "go-form-group-label",
        props: {},
        computed: {}
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/formVue/go-form-group-label.vue